import pixelsApi from 'api/requests/pixels'
import Button from 'components/_UI/Button'
import Loader from 'components/_UI/Loader'
import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import { useEvent } from 'context/events/Event'
import React, { useState } from 'react'
import styled from 'styled-components'
import { FullyCentered } from 'styled/alignment/Center'
import { Column } from 'styled/alignment/Column'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'

export default function PixelDeleteModal({ data, visible, onClose, onSuccess }) {
    const { event } = useEvent()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)

    async function deletePixel() {
        setLoading(true)
        setError(false)

        try {
            await pixelsApi.delete(event?.slug, data?.id)
            onSuccess('deletePixel')
        } catch (error) {
            setError(true)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal isOpen={visible} onClose={onClose}>
            <Text name='highlight'>
                Excluir pixel
            </Text>

            <Text name='normal' marginTop='10px'>
                Tem certeza que quer excluir o pixel <b>{data?.pixel_id}</b>?
            </Text>

            {loading ? (
                <FullyCentered height='40px'>
                    <Loader />
                </FullyCentered>
            ) : (
                <ButtonsContainer>
                    <Button
                        variant='light'
                        category='roundedBorded'
                        onClick={onClose}
                    >
                        Cancelar
                    </Button>

                    <Button
                        category='roundedBorded'
                        variant='lightBlue'
                        onClick={deletePixel}
                    >
                        Excluir
                    </Button>
                </ButtonsContainer>
            )}

            {error && (
                <Text color={colors.danger} name='small'>
                    Ocorreu um erro inesperado, tente novamente!
                </Text>
            )}
        </Modal>
    )
}

const ButtonsContainer = styled(Column)`
    margin-top: 20px;

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;

        button:nth-child(2) {
            margin-left: 10px;
        }
    }
`
